module.exports = __webpack_public_path__ + "49ec5e9ec9ddef9d91c6bde1f3d9b6b6.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/RU.svg
// module id = t2Jb
// module chunks = 0